import React from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import {ReactComponent as DropIcon} from "../../assets/icons/back_shape.svg";

Accordion.propTypes = {
   status: propTypes.oneOf([1, 0]),
   children: propTypes.element,
   changeMode: propTypes.func,
};
Accordion.defaultProps = {
   title: "Título del acordeon",
   children: <div>Contenido</div>,
   theme: {
      color: "white",
      back: "red",
      titleSize: "1.6em",
      subtitleSize: "1.3em",
   },
   status: 0,
   changeMode: () => {},
};

export default function Accordion({title, children, status, theme, changeMode}) {
   return (
      <AccordionContainer>
         <Summary theme={theme} isOpen={!!status}>
            <p>{title}</p>
            <DropIcon width="2em" height="2em" className={"icon"} onClick={() => changeMode(status === 1 ? 0 : 1)} />
         </Summary>
         {!!status && <Content>{children}</Content>}
      </AccordionContainer>
   );
}

const AccordionContainer = styled.section`
   width: 100%;
   margin-bottom: 2px;
`;

const Summary = styled.div`
   display: block;
   width: 100%;
   background: ${props => props.theme.back};
   user-select: none;
   padding: 0.5em 1em;
   box-sizing: border-box;
   display: flex;
   justify-content: space-between;
   align-items: center;

   & p {
      color: white;
      text-transform: capitalize;
      float: left;
      margin: 0;
      font-size: ${props => props.theme.subtitleSize};
      line-height: ${props => props.theme.subtitleSize};
   }

   & .icon {
      cursor: pointer;
      transform: rotate(-90deg);
      transition: all 420ms linear;

      &:active {
         transition: all 420ms linear;
         transform: scale(0.6) rotate(-90deg);
      }
   }
`;

const Content = styled.article`
   width: 100%;
   padding: 0;
   box-sizing: border-box;
   background: white;
`;
